<template>
  <vs-prompt buttons-hidden title="Update Process Time" :active="showUpdateShipTimeDialog" @close="close">
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>
    <vs-alert title="" :active="error" color="danger">Wasn't able to update process time!</vs-alert>
    <template v-if="order">
      <div class="vx-row mb-1 p-3">
        Are you sure you want to process order {{ order.orderNumber }} as soon as possible?
      </div>
      <div class="vx-row">
        <div class="vx-col w-full my-2">
          <vs-button
            class="float-right"
            color="primary"
            type="border"
            :disabled="loading"
            @click="updateOrderShipTime"
          >
            Yes
          </vs-button>
          <vs-button
            class="float-right mr-2"
            color="primary"
            @click="close"
            :disabled="loading"
          >
            No
          </vs-button>
        </div>
      </div>
    </template>
  </vs-prompt>
</template>

<script>
  import api from '@/http/api';
  // import moment from 'moment';

  export default {
    props: [
      'showUpdateShipTimeDialog',
      'order',
      'refresh'
    ],
    data() {
      return {
        loading: false,
        error: false
      }
    },
    methods: {
      async updateOrderShipTime() {
        if (this.loading) return;

        this.error = false;
        this.loading = true;

        const result = await api.updateOrderShipTime(this.order._id);

        this.loading = false;
        if (!result) return this.error = true;

        await this.refresh();
        this.close();
      },
      close() {
        this.error = false;
        this.$emit('update:showUpdateShipTimeDialog', false);
      },
    }
  }
</script>
